var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.75a.75.75 0 01.743.648l.007.102v4.188L5.97 8.97a.75.75 0 011.133.976l-.073.084-3.72 3.72H7.5a.75.75 0 01.743.648l.007.102a.75.75 0 01-.648.743l-.102.007H1.472a.754.754 0 01-.046-.004l.074.004a.754.754 0 01-.601-.301l.07.081a.753.753 0 01-.212-.428L.75 14.5v-6a.75.75 0 01.75-.75zm13-7h.017c.02 0 .04.002.06.004L14.5.75a.754.754 0 01.601.301l-.07-.081a.753.753 0 01.212.428l.007.102v6a.75.75 0 01-1.493.102L13.75 7.5V3.31l-3.72 3.72a.75.75 0 01-1.133-.976l.073-.084 3.718-3.72H8.5a.75.75 0 01-.743-.648L7.75 1.5a.75.75 0 01.648-.743L8.5.75h6z",
    fill: "#61656F",
    fillRule: "nonzero"
  })));
}
export default SvgExpand;